import React from 'react';
import blackandwhite from '../assets/images/monty-b.jpg'; 
import { Helmet } from 'react-helmet';

const Home = () => {
    return (
        <div className="homediv">
            <Helmet>
                <title>Rafsan Bari - Web Developer</title>
                <meta name="description" content="Solving problem, one line of code at a time" />
            </Helmet>
            <div className="bcard">
                <img id="bioimg" src={blackandwhite} alt="Rafsan Bari"/>
                <h1 className="homeName display-1">RAFSAN BARI</h1>
            </div>
            <div className="devcard">
                <h2 className="homeSkil display-1">WEB DEVELOPER</h2>
                <h3 className="catchPhrase">SOLVING PROBLEMS, ONE LINE OF CODE AT A TIME</h3>
            </div>
        </div>
    )
}

export default Home;